import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { getAppsflyerFromCookie } from '@dragonfruit/utils/appsflyers';

import {
  apiFetchChangeablePlans,
  apiCheckoutChangePlan,
} from '@dragonfruit/services/apis';

import {
  FETCH_CHANGEABLE_LIST,
  CHECKOUT_CHANGE_PLAN,
  fetchChangeableListFailure,
  fetchChangeableListSuccess,
  checkoutChangePlanFailure,
  checkoutChangePlanSuccess,
  getCurrentPlan,
} from '@dragonfruit/redux/purchase/changePlan';
import { getDiscountCode } from '@dragonfruit/redux/discountCode';
import { goToAccountSubscriptionsPage } from '@dragonfruit/redux/navigation';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';

import { ALERT_SUCCESS_THEME } from '@dragonfruit/constants/alertBannerThemes';

import { transformPlanList } from './transformPlans';

export function* fetchChangeablePlanListFlow(action) {
  const { changePlanType, subscriptionId, token } = action.payload;

  let apiParams = {
    subscriptionId,
    action: changePlanType,
  };

  if (!!token) apiParams = { ...apiParams, token };
  try {
    const { currentPlan, plans } = yield call(
      apiFetchChangeablePlans,
      apiParams
    );

    const transFormedPlans = transformPlanList(plans);
    yield put(
      fetchChangeableListSuccess({
        currentPlan,
        changeableList: transFormedPlans,
      })
    );
  } catch (err) {
    yield put(fetchChangeableListFailure(err));
  }
}

export function* checkoutChangePlanFlow(action) {
  const {
    changePlanType,
    paymentMethodId,
    paymentMethodNonce,
    invoiceInfo,
  } = action.payload;
  const discountCode = yield select(getDiscountCode);
  const { id: originalPlanId } = yield select(getCurrentPlan);
  const appsflyerSale = getAppsflyerFromCookie();

  try {
    let checkoutData = {
      originalPlanId,
      paymentMethodId,
      action: changePlanType,
      paymentMethodNonce,
      invoiceInfo,
    };

    if (!!discountCode) {
      checkoutData.code = discountCode;
    }

    if (appsflyerSale) {
      checkoutData.appsflyerSale = appsflyerSale;
    }

    yield call(apiCheckoutChangePlan, checkoutData);
    yield put(checkoutChangePlanSuccess());
    yield put(
      showAlertBanner({
        message: 'account:account.updatePlanSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
    yield put(goToAccountSubscriptionsPage());
  } catch (error) {
    yield put(checkoutChangePlanFailure(error.message));
  }
}

export default function*() {
  yield all([
    takeLatest(FETCH_CHANGEABLE_LIST, fetchChangeablePlanListFlow),
    takeLatest(CHECKOUT_CHANGE_PLAN, checkoutChangePlanFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/changePlan.js